import { DateTime } from 'luxon';
import { generateUrlParams } from '../../Utils';

const hostUrl = process.env.REACT_APP_ADAL_HOST_URL;
const tenant = process.env.REACT_APP_ADAL_TENANT;
const clientId = process.env.REACT_APP_ADAL_CLIENT_ID;
const redirectUri = process.env.REACT_APP_ADAL_REDIRECT_URI;

export const generateAuthorizeUrl = (options) => {
  const params = {
    response_type: options?.responseType || 'code',
    client_id: clientId,
    redirect_uri: redirectUri,
    domain_hint: 'rwe-ag.com',
    scope: 'openid email profile',
    state: JSON.stringify({
      redirect: !!options?.redirect,
      referer: options?.referer || '/',
    }),
    nonce: DateTime.now().toMillis(),
  };

  return `${hostUrl}/${tenant}/oauth2/authorize?${generateUrlParams(params)}`;
};
